import { CurrentForecast } from '@/models/CurrentForecast';

type TemperatureProps = Pick<CurrentForecast, 'temperature' | 'windTemperature' | 'description'>;

const Temperature = ({ temperature, windTemperature, description }: TemperatureProps) => (
  <div className="ml-2.5 lg:ml-0 lg:mr-2.5 xl:w-[270px]">
    <div className="lg:flex">
      <div className="pt-3 text-4xl font-medium text-grey-900 dark:text-white lg:pt-0 lg:text-5xl xl:text-6xl">
        {temperature}&deg;
      </div>
      <div className="mt-0.5 text-sm text-blue-grey-500 dark:text-blue-grey-200 lg:mt-0 lg:ml-1.5 lg:pt-1.75 xl:hidden">
        Ощущается <br className="hidden lg:inline" />
        как&nbsp;{windTemperature}&deg;
      </div>
      <div className="ml-1.5 hidden pt-4.5 text-sm leading-5 text-blue-grey-500 dark:text-blue-grey-200 xl:ml-1.5 xl:block">
        При ветре <br />
        ощущается&nbsp;как&nbsp;{windTemperature}&deg;
      </div>
    </div>
    <div className="mt-2.5 hidden text-lg leading-tight text-grey-800 dark:text-white lg:block xl:mt-3">
      {description}
    </div>
  </div>
);

export default Temperature;
